import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import ReactModal from 'react-modal';

import { TrainingOfferingCategory } from '../../../../adl-gen/totalinteraction/futurefit/db';
// import { ComparisonRoles } from "../../../../adl-gen/totalinteraction/futurefit/frontend";
// import { withI18n, WithI18nProps } from "../../../../internationalization/i18n-hoc";
import { i18next } from '../../../../internationalization/i18next';
import { CloseIcon, FilterSVGIcon } from '../../../common/icons';
import { Button } from '../../../widgets/button/button';
import { Item, SearchableCheckItemSet } from '../../../widgets/searchable-check-item-set/searchable-check-item-set';
import { FilterOption, FilterOptionVisibility } from '../common/enabled-disabled-map';
// import { InputState, newTextField } from "../../../widgets/text-input/text-field";
// import { TextInput } from "../../../widgets/text-input/text-input";

ReactModal.setAppElement('#root');

const styles = require('../filter.css');

interface RecommendationCategoryFilterProps {
  //} extends WithI18nProps {
  initial: TrainingOfferingCategory[];
  // defaultRoleId: string;
  // otherRoleIds: string[];
  options: FilterOption<TrainingOfferingCategory>[];
  // rolesMap: ComparisonRoles["roles"];

  onCancel(): void;
  onDone(selected: TrainingOfferingCategory[]): void;
}

interface Toggle {
  label: string;
  detail: string;
}

@observer
export class RecommendationCategoryFilter extends React.Component<RecommendationCategoryFilterProps> {
  // @observable
  // searchState: InputState = textFieldState();

  @observable
  categoriesSelected: TrainingOfferingCategory[] = this.props.initial;

  render() {
    // console.log("DEBUG RolesFilter render: inital/default/other/map: ",
    //   this.props.initial, this.props.defaultRoleId, this.props.otherRoleIds, this.props.rolesMap);
    return (
      <ReactModal
        isOpen={true}
        shouldCloseOnEsc={true}
        shouldCloseOnOverlayClick={true}
        onRequestClose={this.props.onCancel}
        className={styles.modal}
      >
        {this.renderCloseButton()}
        {this.renderTitle()}
        {/* {this.renderSearch()} */}
        {this.renderCheckItems()}
        <br />
        {this.renderButtons()}
      </ReactModal>
    );
  }

  renderCloseButton(): JSX.Element {
    return (
      <div className={styles.closeButton}>
        <CloseIcon onClick={this.props.onCancel} size={'xsmall'} />
      </div>
    );
  }

  renderTitle(): JSX.Element {
    return (
      <div className={styles.title}>
        <FilterSVGIcon className={styles.filterIcon} size={'small'} />
        <div className={styles.titleText}>{i18next.t('filters.recommendation-categories.title', 'Type')}</div>
      </div>
    );
  }

  // renderSearch(): JSX.Element {
  //   return (
  //     <div className={styles.search}>
  //       <TextInput
  //         placeholder={i18next.t("filters.placeholder","Search")}
  //         state={this.searchState}
  //         type={"text"}
  //       />
  //     </div>
  //   );
  // }

  renderCheckItems(): JSX.Element {
    // /// We are going to put the default role first in the list, but we don't want it to be
    // /// duplicated further down, so weed it out if it's there
    // const defaultItemIdx = this.items.findIndex(item => item.id === this.props.defaultRoleId);
    // if (defaultItemIdx >= 0) { this.items.splice(defaultItemIdx, 1); }
    // /// Case-insensitive search - first clean up the expression so it's a valid regex
    // const term = this.searchState.value().replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    // const re = new RegExp(term, 'i');
    this.items.sort((a, b) => a.value.label.localeCompare(b.value.label));
    return (
      <div className={styles.checkItems}>
        <SearchableCheckItemSet
          items={
            // [this.idToItem(this.props.defaultRoleId, this.rolesSelected.concat(this.props.defaultRoleId))]
            // .concat(
            this.items
            // )
            // .filter(i => i.value.label.search(re) !== -1)
          }
          hintText={t => t.detail}
          label={t => t.label}
          onChange={this.onChange}
          selectAllVisible={false}
        />
      </div>
    );
  }

  renderButtons(): JSX.Element {
    return (
      <div className={styles.buttons}>
        <Button
          // className={classnames(styles.button, styles.clear)}
          variant={'tertiary'}
          onClick={async () => this.onClear()}
        >
          {i18next.t('filters.clear', 'Clear Filter')}
        </Button>
        <Button
          // className={classnames(styles.button, styles.report)}
          onClick={async () => this.props.onDone(this.selectedIds)}
          disabled={false}
        >
          {this.selectedIds.length > 0
            ? i18next.t('filters.recommendation-categories.categories', {
                count: this.categoriesSelected.length,
                defaultValue: `Report on ${this.categoriesSelected.length} categories`
              })
            : i18next.t('filters.recommendation-categories.clear', 'Clear Category selections')}
        </Button>
      </div>
    );
  }

  @action
  onClear(): void {
    this.categoriesSelected = [];
  }

  @action
  onChange = (onChangeId: string): void => {
    // if (onChangeId === this.props.defaultRoleId) {
    //   return;
    // }
    const exists = this.selectedIds.find(id => this.stringIdToCategory(onChangeId) === id);
    // tslint:disable-next-line: prefer-conditional-expression
    if (exists !== undefined) {
      this.selectedIds = this.selectedIds.filter(categoryId => this.stringIdToCategory(onChangeId) !== categoryId);
    } else {
      //if (this.selectedIds.length < 3) { // Only select if there aren't already three selected
      this.selectedIds = this.selectedIds.concat(this.stringIdToCategory(onChangeId));
    }
  };

  @computed
  get selectedIds(): TrainingOfferingCategory[] {
    return this.categoriesSelected;
  }

  set selectedIds(ids: TrainingOfferingCategory[]) {
    this.categoriesSelected = ids;
  }

  @computed
  get allIds(): FilterOption<TrainingOfferingCategory>[] {
    return this.props.options;
  }

  @computed
  get items(): Item<Toggle>[] {
    return this.allIds.map(categoryId => this.idToItem(categoryId.value, this.selectedIds, categoryId.visibility));
  }

  idToItem(
    id: TrainingOfferingCategory,
    selected: TrainingOfferingCategory[],
    visibility: FilterOptionVisibility
  ): Item<Toggle> {
    return {
      id: this.categoryToStringId(id),
      selected: selected.includes(id),
      value: this.categoryToToggle(id),
      disabled: visibility === 'always-available' || visibility === 'disabled'
    };
  }

  categoryToToggle(id: TrainingOfferingCategory) {
    // const { t } = this.props;
    let label = '';
    switch (id) {
      case TrainingOfferingCategory.elearning:
        label = i18next.t('recommendations-categories.elearning', 'eLearning');
        break;
      case TrainingOfferingCategory.face2face:
        label = i18next.t('recommendations-categories.face2face', 'Face to Face');
        break;
      default:
        label = i18next.t('recommendations-categories.virtual', 'Virtual Live');
    }
    return {
      label,
      detail: ''
    };
  }

  /// Only required for TrainingOfferingCategory
  categoryToStringId(id: TrainingOfferingCategory) {
    switch (id) {
      case TrainingOfferingCategory.elearning:
        return 'elearning';
      case TrainingOfferingCategory.face2face:
        return 'face2face';
      default:
        return 'virtual';
    }
  }
  stringIdToCategory(id: string) {
    switch (id) {
      case 'elearning':
        return TrainingOfferingCategory.elearning;
      case 'face2face':
        return TrainingOfferingCategory.face2face;
      default:
        return TrainingOfferingCategory.virtual;
    }
  }
}

// export const RecommendationCategoryFilter = withI18n(RecommendationCategoryFilter0);

// function textFieldState(initialValue: string = "") {
//   const state = newTextField();
//   state.onChange(initialValue);
//   return state;
// }



// WEBPACK FOOTER //
// ./src/ui/components/filters/recommendation-category-filter/recommendation-category-filter.tsx